import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import PalletDashboardHeader from '../../components/pallets/PalletDashboard/PalletDashboardHeader';
import PalletDashboardList from '../../components/pallets/PalletDashboard/PalletDashboardList';
import PalletPlantDetails from '../../components/pallets/PalletPlantDetails/PalletPlantDetails';

import { useSessionContext } from '../../contexts/SessionContext';


export default function PalletDashboardPage( props ){
    //console.debug("RTS Break PalletDashboardPage");

    const {userAuthToken, apiRoot} = useSessionContext();

    const [data, setData] = useState([]);

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody] = useState("");
    const [errorTitle] = useState("Validation Error");

    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [actionData, setActionData] = useState([]);
    const [plantData, setPlantData] = useState(null);

    const fetchData = useCallback(() => {
        let apiURL = apiRoot + "/PalletDashboard/GetPalletList";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
               setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        fetchData();
    }, [props, fetchData]);  


    function openDetails(pPlant){
        setPlantData(pPlant);

        let apiURL = apiRoot + "/PalletActions/GetPalletActionsByPlant";
        axios
        .post(
            apiURL,
            pPlant,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setActionData(response.data);
                setShowDetailsModal(true);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });        
    }
    

    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showDetailsModal}>
            <DialogTitle>Plant Details</DialogTitle>
            <DialogContent>
                <Box sx={{minHeight:"400px"}}>
                    <PalletPlantDetails actionData={actionData} plantData={plantData}  setShowDetailsModalFx={setShowDetailsModal} />
                </Box>            
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowDetailsModal(false);}}>Close</Button>
            </DialogActions>            
        </Dialog>        
        <Box>
            <Box sx={{mt:2}}>
                <PalletDashboardHeader />
            </Box>
            <Box sx={{mt:2}}>           
                <PalletDashboardList data={data} openDetailsFx={openDetails} />
            </Box>
        </Box>
        </>
    );
}
